const MAX_VENUE_MAP_URL_LENGTH = 2000;

export const VENUE_MAP_URL_ERROR = 'Venue map link must be an http(s) URL';

/** Any http or https URL, including short Google Maps links such as maps.app.goo.gl. */
export function isVenueMapUrl(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed || trimmed.length > MAX_VENUE_MAP_URL_LENGTH) return false;

  let url: URL;
  try {
    url = new URL(trimmed);
  } catch {
    return false;
  }

  if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
  if (url.username || url.password) return false;
  return true;
}

/** Blank becomes null. A non-URL is an error so the stored value can be opened as a link. */
export function parseVenueMapUrl(
  value: unknown,
): { ok: true; url: string | null } | { ok: false; error: string } {
  if (value == null || value === '') return { ok: true, url: null };
  if (typeof value !== 'string') return { ok: false, error: VENUE_MAP_URL_ERROR };
  const trimmed = value.trim();
  if (!trimmed) return { ok: true, url: null };
  if (!isVenueMapUrl(trimmed)) return { ok: false, error: VENUE_MAP_URL_ERROR };
  return { ok: true, url: trimmed };
}
